import React from 'react';

/** Menbirinchi brand mark — green tile + “1” */
export default function Logo({ size = 28, className = '' }) {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <rect width="32" height="32" rx="10" fill="#00FF85" />
      <path
        fill="#0D1317"
        d="M18.25 7.25c0-.69-.56-1.25-1.25-1.25h-.2c-.4 0-.78.19-1.02.51L11.9 12.2a1.25 1.25 0 0 0 2.02 1.47l1.83-2.52v11.1c0 .69.56 1.25 1.25 1.25h.1c.69 0 1.25-.56 1.25-1.25V7.25z"
      />
      <rect x="10.5" y="23.25" width="11" height="2.5" rx="1.25" fill="#0D1317" />
    </svg>
  );
}
